export default api => ({
    list: () => api.get('/entities/dictionaries'),
    get: ({ dictKey }) => api.get(`/entities/dictionaries/${dictKey}`),
    create: params => api.post(`/entities/dictionaries`, params),
    delete: ({ dictKey }) => api.delete(`/entities/dictionaries/${dictKey}`),
    edit: ({ dictKey, params }) => api.put(`/entities/dictionaries/${dictKey}`, params),
    order: ({ dictKey, fieldType, params }) => api.put(`/entities/dictionaries/${dictKey}/${fieldType}`, params),

    fieldCreate: ({
        dictKey, fieldType, params,
    }) => api.post(`/entities/dictionaries/${dictKey}/${fieldType}`, params),
    fieldDelete: ({
        dictKey, fieldType, fieldId, params,
    }) => api.delete(`/entities/dictionaries/${dictKey}/${fieldType}/${fieldId}`, params),
    fieldEdit: ({
        dictKey, fieldType, fieldId, params,
    }) => api.put(`/entities/dictionaries/${dictKey}/${fieldType}/${fieldId}`, params),
})
